import React, { Fragment } from "react"
import { Link } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import Button from "components/common/Button"
import Avatar from "components/common/Avatar"
import "./index.scss"
import cx from "classnames"
import { formatDate, formatTimestamp } from "helpers/util"

class TopicCard extends React.Component {
  constructor() {
    super()

    this.state = {
      isMenuOpen: false,
    }
  }

  toggleMenu = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
    })
  }

  handleMenuClick = (onAction) => {
    this.toggleMenu()
    if (onAction) {
      onAction()
    }
  }

  hasSeeMore = (content) => {
    var lines = content && content.split("\n")
    return lines?.length > 5 ? true : false
  }

  render() {
    const {
      id,
      author,
      photo,
      pubTimestamp,
      editTimestamp,
      reply = 0,
      views = 0,
      upvotes = 0,
      downvotes = 0,
      title,
      content,
      tags,
      buttonEnabled,
      linkDisabled,
      isAuthor = false,
      isClosed = false,
      onClickComment,
      onClickAnswer,
      onClickUpvote,
      onClickDownvote,
      onClickEdit,
      onClickClose,
      voteStatus,
      color,
      isList,
    } = this.props

    const { isMenuOpen } = this.state

    const hasSeeMore = this.hasSeeMore(content)
    return (
      <div className="topic-card">
        <div className="vote-count">
          <>
            <span
              className={cx("icon-up", isAuthor && "is-author")}
              onClick={!isAuthor && onClickUpvote}
              style={{
                color: voteStatus === "up" && color,
              }}
            />
            <p className="text">{upvotes - downvotes}</p>
            <span
              className={cx("icon-down", isAuthor && "is-author")}
              onClick={!isAuthor && onClickDownvote}
              style={{
                color: voteStatus === "down" && color,
              }}
            />
            {isAuthor && !isClosed && (
              <>
                <span
                  className="icon-exam"
                  onClick={() => this.handleMenuClick(onClickEdit)}
                ></span>
                <span
                  className="icon-outline"
                  onClick={() => this.handleMenuClick(onClickClose)}
                />
              </>
            )}
          </>
        </div>
        <div className="topic-details">
          <h3 className="title">
            {linkDisabled ? (
              title
            ) : (
              <Link to={`/forums/topic/${id}`}>{title}</Link>
            )}
            <p className="date">{formatDate(pubTimestamp)}</p>
          </h3>
          <div className="topic-content">
            <p className={cx("body", isList && "list")}>{content}</p>
            {isList && hasSeeMore && (
              <p style={{ fontStyle: "italic", color: color }}>
                <Link to={`/forums/topic/${id}`}> See more </Link>
              </p>
            )}
            {tags &&
              tags.map((tag, idx) => {
                return (
                  <Link
                    key={idx}
                    className="tags"
                    to={`/forums/search?tag=${tag}`}
                  >
                    {tag}
                  </Link>
                )
              })}
            {buttonEnabled && (
              <div className="actions has-text-right">
                <Button
                  label="Answer this Question"
                  size="small"
                  onClick={onClickAnswer}
                />
                <Button
                  label="Post Comment"
                  size="small"
                  customClassName="mr-m"
                  onClick={onClickComment}
                />
              </div>
            )}
          </div>
          <div className="author-details">
            <Avatar size="24" name={author} src={photo} />
            Posted by <span className="name">{author}</span>
            <div className="timestamp">
              {editTimestamp && pubTimestamp !== editTimestamp ? (
                <Fragment>
                  <ReactTooltip effect="solid" id={`topicCard`} />
                  <span
                    className="edited"
                    data-tip={formatTimestamp(editTimestamp)}
                    data-for={`topicCard`}
                  >
                    edited
                  </span>
                </Fragment>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={cx("topic-stats", isMenuOpen && "is-active")}>
            <span className="icon-reply" />
            <p className="replies">{reply}</p>
            <span className="icon-eye" />
            <p className="views">{views}</p>
          </div>
        </div>
      </div>
    )
  }
}

export default TopicCard
